export default __webpack_public_path__ + "static/media/Helm of the Farseeker.15f2d869.jpg";